"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var define_reactive_1 = __importDefault(require("../common/define-reactive"));
var echarts = __importStar(require("echarts"));
require("echarts-liquidfill");
var util_1 = require("../common/util");
var chart_1 = require("../types/chart");
var merge_1 = __importDefault(require("lodash/merge"));
var parser_1 = require("../parser");
var BaseChart = /** @class */ (function () {
    function BaseChart(options, page, theme, component, inputOptions) {
        var _this = this;
        this.$rendering = false;
        this.$status = "init";
        this.$component = component;
        this.$inputOptions = inputOptions;
        /**
         * 导出配置信息
         */
        this.export = function () {
            return {
                dataset: _this.$dataset,
                config: _this.$inputOptions,
                charts: _this.$options.config
            };
        };
        this.$page = page;
        var data = {};
        if (component && typeof component.data === "function") {
            data = component.data.call(this);
        }
        this.$theme = theme;
        this.$options = this.optionDefineReactive(merge_1.default({}, parser_1.genChart(options), data));
    }
    /**
     * 触发生命周期
     * @param type
     */
    BaseChart.prototype.invokeHook = function (type) {
        var _a;
        this.$status = type;
        if (this.$component && typeof this.$component[type] === "function") {
            (_a = this.$component[type]) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    };
    /**
     * 响应式
     * @param options
     */
    BaseChart.prototype.optionDefineReactive = function (options) {
        var _this = this;
        return define_reactive_1.default(options, {
            set: function (target, key, value, receiver) {
                if (key === "position") {
                    _this.$el && _this.$page && _this.$page.layoutAdapter(_this.$el, _this.$options);
                    _this.$chart.resize();
                }
                else if (_this.$status !== "init") {
                    _this.forceUpdate();
                }
            }
        });
    };
    /**
     * 设置样式
     */
    BaseChart.prototype.setTheme = function () {
        this.$el.style.cssText += util_1.buildStyleWithTheme(this.$options.theme).join(";");
        this.$page && this.$page.layoutAdapter(this.$el, this.$options);
        this.$chart && this.$chart.resize();
    };
    /**
     * 渲染
     */
    BaseChart.prototype.render = function () {
        this.invokeHook(chart_1.HookType.beforeRender);
        // let options = this.buildChartOptions();
        var options = this.$options.config;
        // 检查是否存在自定义的数据组装逻辑
        if (this.$component && typeof this.$component.buildChartOptions === "function") {
            options = this.$component.buildChartOptions.call(this, options);
        }
        this.$chart.setOption(options);
        this.invokeHook(chart_1.HookType.afterRender);
    };
    /**
     * 挂载图表
     * @param el
     * @param page
     */
    BaseChart.prototype.amount = function (el, page) {
        var _this = this;
        this.invokeHook(chart_1.HookType.beforeCreate);
        if (typeof el === "string") {
            this.$el = document.getElementById(el);
        }
        else {
            this.$el = el;
        }
        if (!this.$el) {
            throw Error("el is not exist !!!");
        }
        if (page) {
            this.$page = page;
        }
        this.setTheme();
        // 挂载
        this.$page && this.$page.add(this.$el);
        var themeName = "realTheme";
        typeof this.$theme === "string"
            ? (themeName = this.$theme)
            : echarts.registerTheme("realTheme", this.$theme);
        this.$chart = echarts.init(this.$el, themeName);
        this.invokeHook(chart_1.HookType.created);
        // 渲染
        this.render();
        window.addEventListener("resize", function () {
            _this.$chart.resize();
        });
        return this.$chart;
    };
    /**
     * 更新
     * @param options
     */
    BaseChart.prototype.update = function (options) {
        if (this.$chart) {
            this.$chart.setOption(options);
        }
        else {
            merge_1.default(this.$options, { config: parser_1.genChart(options) });
            // this.forceUpdate();
        }
    };
    /**
     * 更新数据
     * @param data
     */
    BaseChart.prototype.dataSet = function (data) {
        this.$dataset = data;
        if (this.$chart) {
            this.$chart.setOption({ dataset: data });
        }
        else {
            merge_1.default(this.$options, { config: { dataset: data } });
            // this.forceUpdate();
        }
        return this;
    };
    /**
     * 触发更新
     */
    BaseChart.prototype.forceUpdate = function () {
        var _this = this;
        if (this.$rendering) {
            return;
        }
        this.$rendering = true;
        Promise.resolve().then(function () {
            _this.setTheme();
            _this.render();
            _this.$rendering = false;
        });
    };
    /**
     * 删除
     */
    BaseChart.prototype.remove = function () {
        this.invokeHook(chart_1.HookType.beforeDestroy);
        this.$chart.dispose();
        // this.$el!.remove();
        this.invokeHook(chart_1.HookType.destroyed);
    };
    return BaseChart;
}());
exports.default = BaseChart;
//# sourceMappingURL=BaseChart.js.map